<template>
<div class="container-base"
     v-once>
  <div class="bokumetsu-pages page-static">
    <div class="page-static-inner">
      <section class="hero">
        <img src="/static/img/pages/bokumetsu/main.svg" alt="日本からはみ出した手書き履歴書の山に乗った黒ヤギと、くるくる回る地球" class="mainimg">
        <h1><img src="/static/img/pages/bokumetsu/h1.svg" alt="yagish（ヤギッシュ）手書き履歴書撲滅キャンペーン"></h1>
      </section>
      <section class="introduction">
        <div class="sectiontop">
          <h2>履歴書は手書き不要の時代へ</h2>
          <p>履歴書は就職活動や転職で提出を求められることが多い書類です。<br>
          求人への応募もウェブ上で行うシーンが多くなったいま、
          「履歴書が手書きであること」だけで人柄や会社への熱意をはかる意味合いは徐々に薄れ、パソコンなどで作成した履歴書で応募できる企業も増えてきました。</p>
        </div>
        <div class="container980">
          <div class="merit">
            <div class="circle">
              <img src="/static/img/pages/bokumetsu/merit.svg" alt="手書き不要のメリット">
            </div>
            <div class="flex">
              <div class="left">
                <h3>応募者のメリット</h3>
                <img src="/static/img/pages/bokumetsu/jikanniyoyuu.svg" alt="時計を持つヤギのイメージ">
                <p>時間が増える</p>
                <img src="/static/img/pages/bokumetsu/syutyu.svg" alt="パソコンとスマートフォンを前に集中しているヤギのイメージ">
                <p>書く内容に集中できる</p>
                <img src="/static/img/pages/bokumetsu/suguoubo.svg" alt="履歴書を沢山持ちながら就職先を思い描くヤギのイメージ">
                <p>いいな！と思ったらすぐ応募できる</p>
              </div>
              <div class="right">
                <h3>採用者のメリット</h3>
                <img src="/static/img/pages/bokumetsu/yomiyasui.svg" alt="デジタル履歴書の読みやすさをアピールするヤギのイメージ">
                <p>応募内容が読みやすい</p>
                <img src="/static/img/pages/bokumetsu/kanisiyasui.svg" alt="A社とB社を見比べるヤギのイメージ">
                <p>データで管理しやすい</p>
                <img src="/static/img/pages/bokumetsu/ouboshitai.svg" alt="嬉しそうな企業とヤギのイメージ">
                <p>応募してもらいやすい</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="worry">
        <div class="container980">
          <div class="sectiontop">
            <h2>とは言っても…手書きじゃないと心配な理由</h2>
          </div>
          <div class="flex">
            <div class="worry-content">
              <img src="/static/img/pages/bokumetsu/konki.svg" alt="筆で「根気」と手書きされた文字のイメージ">
              <div class="worry-content-inner">
                <h3>手書きの方が好印象？</h3>
                <p>募集要項での指定はないものの、手書きのメリットとされている「熱意や誠意が伝わりやすさ」が有利にはたらくかも…と考えてしまいます。</p>
              </div>
            </div>
            <div class="worry-content">
              <img src="/static/img/pages/bokumetsu/hidennosyo.svg" alt="侍ヤギが「400年前から伝わる秘伝の履歴書採用術」と書かれた巻物を持っているイメージ">
              <div class="worry-content-inner">
                <h3>周りに手書きを勧められる</h3>
                <p>『履歴書は手書き』とされていた時代の方がまだまだ長いため、採用の相談に乗っている人が、良かれと思って手書きを薦めている場合があります。</p>
              </div>
            </div>
            <div class="worry-content">
              <img src="/static/img/pages/bokumetsu/tegakirirekisyo.svg" alt="ヤギが書いた手書きの履歴書のイメージ">
              <div class="worry-content-inner">
                <h3>「迷ったら手書き」が無難？</h3>
                <p>マニュアル本やWEBサイトでは「迷ったら手書き」としているところが多く、応募者側・採用者側どちらも望んでいないのに、結果として「手書きのほうが無難」な現状になってしまっています。</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="yagi-friends">
        <!-- 君はもうヤギとおともだちだよ！🐐 -->
        <div class="container980">
          <div class="sectiontop">
            <h2>ヤギからの提案：手書き不要を表明してみませんか？</h2>
            <p class="thought-content">
              <span>『手書き不要』</span>を表明すれば
              手書きで迷わなくていいし、
              みんな幸せになれるかも！
            </p>
          </div>
          <div class="profile">
            <div class="profile-inner">
              <img src="/static/img/pages/bokumetsu/moguyagi.svg" alt="ヤギのプロフィールを紹介するヤギのイラスト" class="moguyagi">
              <h3><img src="/static/img/pages/bokumetsu/yaginopr.svg" alt="ヤギのプロフィール" class="yagipr"></h3>
              <a href="/gacha" target="_blank"><img src="/static/img/pages/bokumetsu/bokumetsuyagi-l.png" alt="ぴょんぴょん跳ねる元気な左向きの黒ヤギ" class="tobuyagi-l"></a>
              <a href="/gacha" target="_blank"><img src="/static/img/pages/bokumetsu/bokumetsuyagi-r.png" alt="ぴょんぴょん跳ねる元気な右向きの黒ヤギ" class="tobuyagi-r"></a>
              <p><span class="accent">「手書き履歴書じゃなくても大丈夫！」</span>と思っている友達（企業）を集め、就職活動や、転職活動を頑張る人たちを応援するために日々奮闘中。</p>
              <p>昔はやんちゃをしていて周りの人を悲しませていたが、今は人の為になにかしたいと更生した。毛の色や風貌から怖がられることが多いが、根はやさしい。片方の葉がちぎれているのは古傷。</p>
            </div>
          </div>
        </div>
      </section>
      <section class="juuoku">
          <div class="container980">
            <div class="container700">
              <h2>みんなで協力すれば10億円の経済効果が<span>（あるかも）</span></h2>
              <p>手書きで綺麗に書こうとすると、早くても1枚30分くらいかかってしまう履歴書。内容に悩んだり、間違えるとさらに時間がかかってしまいます。</p>
              <p>日本では毎年40万人を超える人たちが大学を卒業し、新卒として就職します。<br>
                この人たちがひとりあたり5社受けるとすると、手書きで履歴書を書いた場合は約100万時間の時間が使われている計算になります。時給1000円に換算すると、<span class="accent">約10億円分！</span><br>
                転職する人やアルバイトも合わせるとその何倍にもなるでしょう。この時間を学業や自己分析、企業調査に使うことができれば、素敵な企業に出会える可能性があがるかもしれません。</p>
              <div class="waste">
                <div class="waste-inner">
                  <div class="flex">
                    <div class="time">
                      <p>
                        <span>0.5</span><br>時間
                      </p>
                    </div>
                    <div class="kakeru">
                      <p>×</p>
                    </div>
                    <div class="resume">
                      <p>
                        <span>5</span><br>枚
                      </p>
                    </div>
                    <div class="kakeru">
                      <p>×</p>
                    </div>
                    <div class="population">
                      <p><span>40</span><br>万人</p>
                    </div>
                    <div class="equal-vertical">
                      <p>＝</p>
                    </div>
                </div>
                <div class="total">
                  <p>
                    <span class="equal-transverse">＝</span><span class="million">100万</span>時間
                  </p>
                </div>
                </div>
                <img src="/static/img/pages/bokumetsu/juuoku.svg" alt="十億円を咥えたヤギのイラスト" class="juuokuyagi">
              </div>
            </div>
          </div>
        <div class="containerfull campaign">
          <div class="container980">
            <div class="container700">
              <div class="campaign-inner">
                <h3>
                  <img src="/static/img/pages/bokumetsu/yagicampaign.svg" alt="キャンペーンの参加方法">
                </h3>
                <p class="no1">キャンペーンに賛同して頂ける場合は、企業・個人問わず<a href="https://twitter.com/search?q=%23手書き不要" target="_blank">#手書き不要</a>のハッシュタグをつけてツイートしてください</p>
                <p class="no2">企業の場合は、ハッシュタグや一言コメントと一緒に採用ページのURLなども共有していただけると、ツイートを見たユーザーが見に行きやすいのでうれしいです。</p>
                <p class="no3">ヤギとしてはもっと手書き不要が普及するといいなと思っていますが、手書きを否定するキャンペーンではありません。攻撃的なツイートや悪意のある言い方はさけていただけるとうれしいです。</p>
                <div class="bokumetsu-tweet">
                  <p class="accent">『<span>#手書き不要</span>』のハッシュタグでツイートしよう！</p>
                  <a id="footer-social-share-twitter" href="http://twitter.com/intent/tweet?url=https://rirekisho.yagish.jp/bokumetsu/&amp;text=黒ヤギとおともだちになった！ &amp;hashtags=手書き不要,yagish" rel="nofollow" target="_blank">ツイートする
                  </a>
                </div>
              </div>
              <div class="tagyagi">
                <p>ヤギの友達がつぶやいたツイートを見てみる！</p>
                <a href="https://twitter.com/search?q=%23手書き不要" target="_blank">
                  <img src="/static/img/pages/bokumetsu/hashtag.svg" alt="「#手書き不要」のハッシュタグ">
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="back-button">
        <router-link to="/">yagishを使ってみる</router-link>
      </div>
    </div>
  </div>
</div>
</template>
<style lang="scss" src="@/assets/scss/pages/bokumetsu.scss" scoped></style>
<script>
export default {
  data: function () {
    return {}
  },
  computed: {},
  methods: {},
  watch: {},
  mounted: function () {}
}
</script>
